import React from 'react';
import HeroSection from '../components/common/HeroSection';
import YouCanContent from '../components/involvement/YouCan';

const breadcrumb = [
  { key: 'nav.home',   path: '/' },
  { key: 'nav.youCan', path: null },
];

const YouCan = () => (
  <>
    <HeroSection
      titleKey="youCan.title"
      subtitleKey="youCan.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <YouCanContent />
  </>
);

export default YouCan;
